
import {takeUntil} from 'rxjs/operators';
import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef, HostListener, AfterViewInit } from '@angular/core';
import { Global } from '../classes/Global';
import { BaseComponent } from '../classes/BaseComponent';
import { StorageHelper } from '../helpers/StorageHelper';
import { AuthenticationService } from '../authentication.service';
import { SettingsService } from '../settings.service';
import { LoginHelper } from '../helpers/LoginHelper';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { WishlistService } from '../wishlist.service';

import { CountryService } from '../country.service';
import { InfoService } from '../info.service';
import { ModalComponent } from '../modal/modal.component';
import { GlobalService } from '../global.service';
import { StringHelper } from '../helpers/StringHelper';
import { SeoService } from '../seo.service';
import { HttpClient } from '@angular/common/http';
import { Config } from '../classes/Config';
import { CookiesHelper } from '../helpers/CookiesHelper';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [ AuthenticationService, WishlistService, InfoService ]
})
export class HeaderComponent extends BaseComponent implements OnInit, AfterViewInit {

  schema;

  currentCountry = { name: this.getString(Global.getCountry()), icon: Global.countries[Global.getCountry()].icon };
  countries: Array<any>;
  isUserLoggedIn = false;
  deleteAccountError = "";

  newCardDeal: boolean = false;
  initialCountry: string = Global.getCountry();

  showCountryPopup: boolean = false;

  @Output() onCountryChanged = new EventEmitter();
  @ViewChild('storeDDContent', {static: false}) storeDDContent: ElementRef;
  @ViewChild('moreDDContent', {static: false}) moreDDContent: ElementRef;
  @ViewChild('usernameDDContent', {static: false}) usernameDDContent: ElementRef;
  @ViewChild('settingsDDContent', {static: false}) settingsDDContent: ElementRef;

  @ViewChild('authentication', {static: false}) authentication;
  @ViewChild('changeEmailPasswordModal', {static: false}) changeEmailPasswordModal;
  @ViewChild('preferencesModal', {static: false}) preferencesModal;
  @ViewChild('accountSettingsModal', {static: false}) accountSettingsModal;
  @ViewChild('newsModal', {static: false}) newsModal;
  @ViewChild('vuduNewsModal', { static: false }) vuduNewsModal;
  @ViewChild('deleteAccountConfirmationModal', {static: false}) deleteAccountConfirmationModal;
  @ViewChild('amazonBackModal', {static: false}) amazonBackModal;
  @ViewChild('cookieSettingsModal', {static: false}) cookieSettingsModal;
  @ViewChild('submitItemModal', {static: false}) submitItemModal;

  submitItemUrl = '';
  submitItemMessage = '';
  submitItemSuccess = false;
  submitItemLoading = false;
  submitItemLink = '';

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!event || !event.target) {
      return;
    }
    try {
      if (this.elementRef && this.elementRef.nativeElement && !this.elementRef.nativeElement.contains(event.target)) {
        this.closeDropdown(this.moreDDContent);
        this.closeDropdown(this.storeDDContent);
        this.closeDropdown(this.usernameDDContent);
        this.closeDropdown(this.settingsDDContent);
      }
    } catch (e) {
      // Ignore permission errors from cross-origin iframes or restricted contexts
    }
  }

  constructor(
    private authenticationService: AuthenticationService,
    private elementRef: ElementRef,
    private settingsService: SettingsService,
    private router: Router,
    private route: ActivatedRoute,
    private countryService: CountryService,
    private infoService: InfoService,
    private globalService: GlobalService,
    private seoService: SeoService,
    private http: HttpClient
  ) {
    super();
    const self = this;
    this.countries = Object.keys(Global.countries).map(function(key) {
      return {
        key: key,
        name: self.getString(Global.countries[key].string),
        icon: Global.countries[key].icon
      };
    });

    this.isUserLoggedIn = authenticationService.isLoggedIn();
    LoginHelper.getInstance().getSubject().subscribe(value => {
      this.isUserLoggedIn = value;
    });

    // Listen for login requests from other components (e.g. grid-item quick actions)
    // Opens register modal to show benefits of creating an account
    LoginHelper.getInstance().getLoginRequiredSubject().subscribe(() => {
      this.registerClicked();
    });

    //Check if the user has his uniqueCustomId
    if (this.isUserLoggedIn && !StorageHelper.getInstance().get(StorageHelper.keys.uniqueCustomerId)) {
      //He does not have it. Load it ASAP!
      const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
      if(sessionToken) {
        this.infoService.getUserDataBySessionToken(sessionToken, Global.getCountry()).subscribe(res => {
          StorageHelper.getInstance().save(StorageHelper.keys.sessionToken, sessionToken);
          StorageHelper.getInstance().save(StorageHelper.keys.username, res['username']);
          StorageHelper.getInstance().save(StorageHelper.keys.email, res['mail']);
          StorageHelper.getInstance().save(StorageHelper.keys.profileImageUrl, res['profileImage']);
          StorageHelper.getInstance().save(StorageHelper.keys.uniqueCustomerId, res['uniqueCustomerId']);
        }, err => { /*who cares*/ });
      }

    }

  }

  ngAfterViewInit(): void {

    setTimeout(() => { //necessary to make it execute after the current angular loop, otherwise it throws an angular error
      const now = new Date();
      const maxPopupDate = new Date("2021-08-10");

      const nowMinus1Hour = new Date(new Date().setHours(now.getHours()-1));
      const visit = StorageHelper.getInstance().get(StorageHelper.keys.visit);
      const visitMoreThan1HourAgo: boolean = visit && new Date(visit) < nowMinus1Hour;

      if (Global.getCountry() == "us" && visitMoreThan1HourAgo &&
        !StorageHelper.getInstance().get(StorageHelper.keys.newsPopup + "9") &&
        now < maxPopupDate) {
        if(this.newsModal) {
          this.newsModal.open();
          StorageHelper.getInstance().save(StorageHelper.keys.newsPopup + "9", 'true');
        }

      }
      // Show Vudu news popup for logged-in Vudu store visitors
      // TEMPORARILY COMMENTED OUT - will be activated later
      /*
      const maxVuduPopupDate = new Date("2025-12-31");
      if (Global.getStore() == Global.VUDU && this.isUserLoggedIn &&
        !StorageHelper.getInstance().get(StorageHelper.keys.newsPopup + "vudu") &&
        now < maxVuduPopupDate) {
        if (this.vuduNewsModal) {
          this.vuduNewsModal.open();
          StorageHelper.getInstance().save(StorageHelper.keys.newsPopup + "vudu", 'true');
        }
      }
      */
      StorageHelper.getInstance().save(StorageHelper.keys.visit, new Date().getTime());

    });
  }

  ngOnInit() {
    this.getCountryFromUrl();
  }

  get isEU() {
    return this.countryService.isEU;
  }

  getCountryFromUrl() {
    //Notifier
    const ngUnsubscribe: Subject<any> = new Subject();

    //read url queryParams
    this.route.queryParams.subscribe((queryParams: Params) => {
      if(queryParams['invite']) {
        StorageHelper.getInstance().save(StorageHelper.keys.inviteCode, queryParams['invite']);
        StorageHelper.getInstance().save(StorageHelper.keys.inviteCodeTime, new Date().getTime());
      }
    });

    //read url params
    this.route.params.pipe(takeUntil(ngUnsubscribe)) //take values until a notifier emits a value
    .subscribe(params => {

      let countryKey = params['country'];

      //The iOS app gives a wrong url with the country like 'en_us' or 'de_de'
      //So here I only take the second part when its the case
      if (countryKey && countryKey.length > 2){
        const parts = countryKey.split('_');
        if (parts && parts.length >= 2) {
          countryKey = parts[1];
        }
      }

      if (countryKey && Global.countries[countryKey]) {
        StorageHelper.getInstance().save(StorageHelper.keys.country, countryKey);
        this.setLanguageFromCountry(countryKey);
        this.currentCountry = { name: this.getString(countryKey), icon: Global.countries[countryKey].icon };
      }
      else {
        countryKey = Global.getCountry();
        StorageHelper.getInstance().save(StorageHelper.keys.country, countryKey);
        this.setLanguageFromCountry(countryKey);
        this.currentCountry = { name: this.getString(countryKey), icon: Global.countries[countryKey].icon };
        if(this.router.url.indexOf("/apple_redirect") == -1) {
          this.router.navigate(['/' + this.getCountry() + '/404']);
        }
      }
      this.countryService.setCountry(countryKey);

      this.seoService.addSeoData();
      this.seoService.setNoIndexForMinorCountries();
      this.seoService.handleActorsPagesSeo();
      this.buildSchema();

      if(this.initialCountry != countryKey) {
        //show "country changed" popup
        this.showCountryPopup = true;
        setTimeout(() => {
          this.showCountryPopup = false;
        }, 1500);
      }

      this.globalService.getLastCardDealId();

      //Update active country if user is logged in
      if (StorageHelper.getInstance().get(StorageHelper.keys.sessionToken)) {

        this.settingsService.getHidePurchasedItems(
          StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), countryKey)
          .subscribe(res => {}, err => { console.log(err); });

        if(this.initialCountry != countryKey) {

          this.settingsService.updateActiveCountry(this.initialCountry, countryKey,
            StorageHelper.getInstance().get(StorageHelper.keys.sessionToken)).subscribe(res => {

          }, err => {

          });
        }

      }

      ngUnsubscribe.next();
      ngUnsubscribe.complete();
    });
  }

  buildSchema() {
    this.schema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "url": "https://www.cheapcharts.com/" + Global.getCountry(),
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://www.cheapcharts.com/" + Global.getCountry() + '/' + this.getString("searchUrl") + ";q={search_term_string}",
        "query-input": "name=search_term_string"
      }
    };
  }

  getCountryChangedText(): string {
    return StringHelper.format(this.getString("yourCountryHasBeenChanged"), this.getString(Global.countries[this.countryService.getCountry()].string));
  }

  setLanguageFromCountry(countryKey: string) {
    if(countryKey == "de" || countryKey == "at" || countryKey == "ch") {
      StorageHelper.getInstance().save(StorageHelper.keys.lang, "de");
    }
    else if(countryKey == "fr" || countryKey == "be") {
      StorageHelper.getInstance().save(StorageHelper.keys.lang,  "fr");
    }
    else if (countryKey == "es" || countryKey == "mx") {
      StorageHelper.getInstance().save(StorageHelper.keys.lang, "es");
    }
    else {
      StorageHelper.getInstance().save(StorageHelper.keys.lang,  "en");
    }
  }

  selectCountry(country: string) {

    if (!country || !Global.countries[country]) {
      return;
    }

    this.closeDropdown(this.storeDDContent);

    this.currentCountry = { name: this.getString(country), icon: Global.countries[country].icon };
    StorageHelper.getInstance().save(StorageHelper.keys.country, country);
    this.countryService.setCountry(country);
    this.onCountryChanged.emit(country);
    this.setLanguageFromCountry(country);

    this.router.navigate(['/' + country]).then((navigated) => {
      if (navigated && typeof window !== "undefined") {
        window.scrollTo(0, 0);
      }
    });
  }

  loginClicked() {
    this.authentication.openLogin();
  }

  authFailed() {
    this.isUserLoggedIn = false;
    this.authenticationService.setIsLoggedIn(false);
    this.authentication.openLogin();
    this.preferencesModal.close();
  }

  registerClicked() {
    this.authentication.openRegister();
  }

  isLoggedIn(): boolean {
    return this.authenticationService.isLoggedIn();
  }

  logout() {
    this.authenticationService.logout(Global.getCountry(), StorageHelper.getInstance().get(StorageHelper.keys.sessionToken))
    .subscribe(res => {
      if (res){
        Global.clearSaveUserInfos();
        this.authenticationService.setIsLoggedIn(false);
        LoginHelper.getInstance().loginChanged(false);
        const url = LoginHelper.getUrlWithoutSessionToken(this.router.url);
        window.open(url, '_self');
      }
    }, err => {

    });
  }

  moreClicked() {
    this.closeDropdown(this.storeDDContent);
    this.closeDropdown(this.usernameDDContent);
    this.closeDropdown(this.settingsDDContent);

    if (this.moreDDContent && this.moreDDContent.nativeElement && this.moreDDContent.nativeElement.classList.contains('dd-open')) {
      this.closeDropdown(this.moreDDContent);
    }
    else {
      this.openDropdown(this.moreDDContent);
    }
  }

  storeClicked() {
    this.closeDropdown(this.moreDDContent);
    this.closeDropdown(this.usernameDDContent);
    this.closeDropdown(this.settingsDDContent);

    if (this.storeDDContent && this.storeDDContent.nativeElement && this.storeDDContent.nativeElement.classList.contains('dd-open')) {
      this.closeDropdown(this.storeDDContent);
    }
    else {
      this.openDropdown(this.storeDDContent);
    }
  }

  closeDropdown(dropdownRef: ElementRef) {
    if (dropdownRef && dropdownRef.nativeElement) {
      dropdownRef.nativeElement.className = 'dropdown-content dd-right dd-close';
    }
  }

  openDropdown(dropdownRef: ElementRef) {
    if (dropdownRef && dropdownRef.nativeElement) {
      dropdownRef.nativeElement.className = 'dropdown-content dd-right dd-open';
    }
  }

  getUsername(): string {
    return StorageHelper.getInstance().get(StorageHelper.keys.username) || 'Username';
  }

  usernameClicked() {
    this.closeDropdown(this.moreDDContent);
    this.closeDropdown(this.storeDDContent);
    this.closeDropdown(this.settingsDDContent);
    if (this.usernameDDContent && this.usernameDDContent.nativeElement && this.usernameDDContent.nativeElement.classList.contains('dd-open')) {
      this.closeDropdown(this.usernameDDContent);
    }
    else {
      this.openDropdown(this.usernameDDContent);
    }
  }

  accountClicked() {
    this.closeDropdown(this.usernameDDContent);
    this.accountSettingsModal.open();
  }

  myPurchasesClicked() {
    this.closeDropdown(this.usernameDDContent);
    this.router.navigate([Global.getCountry() + '/' + Global.getStoreUrl() + '/' + this.getString(Global.getMediaType() + "Url") + '/' + this.getString('myPurchasesUrl')]);
  }

  myListsClicked() {
    this.closeDropdown(this.usernameDDContent);
    this.router.navigate([Global.getCountry() + '/' + Global.getStoreUrl() + '/' + Global.getMediaTypeForUrl() + '/' + this.getString('myListsUrl')]);
  }

  blocklistClicked() {
    this.closeDropdown(this.usernameDDContent);
    this.router.navigate([Global.getCountry() + '/' + Global.getStoreUrl() + '/' + this.getString(Global.getMediaType() + "Url") + '/' + this.getString('blocklistUrl')]);
  }

  referralsClicked() {
    this.closeDropdown(this.usernameDDContent);
    this.router.navigate([Global.getCountry() + '/' + this.getString('referralsUrl')]);
  }

  notificationSettingsClicked() {
    this.closeDropdown(this.settingsDDContent);
  }

  changeEmailPasswordClicked() {
    this.closeDropdown(this.settingsDDContent);
    this.changeEmailPasswordModal.open();
  }

  logoutClicked() {
    this.closeDropdown(this.usernameDDContent);
    this.logout();
  }

  getProfileImageUrl(): string {
    const profileImageUrl = StorageHelper.getInstance().get(StorageHelper.keys.profileImageUrl) || 'placeholder';
    if (profileImageUrl === 'placeholder') {
      return './assets/images/profile_placeholder.png';
    }
    else {
      return profileImageUrl;
    }
  }

  settingsClicked() {
    this.closeDropdown(this.moreDDContent);
    this.closeDropdown(this.storeDDContent);
    this.closeDropdown(this.usernameDDContent);
    if (this.settingsDDContent && this.settingsDDContent.nativeElement && this.settingsDDContent.nativeElement.classList.contains('dd-open')) {
      this.closeDropdown(this.settingsDDContent);
    }
    else {
      this.openDropdown(this.settingsDDContent);
    }
  }

  preferencesClicked() {
    this.closeDropdown(this.settingsDDContent);
  }

  countryPollClicked() {
    this.closeDropdown(this.storeDDContent);
  }

  deleteAccountClicked() {
    this.deleteAccountError = "";
    this.deleteAccountConfirmationModal.open();
  }

  onDeleteConfirmationResult(result) {
    if (result === ModalComponent.RESULT_YES) {
      this.deleteAccount();
    }
  }

  deleteAccount() {
    this.authenticationService.deleteAccount(Global.getCountry(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken)).subscribe(res => {
      if (res && res["status"] === "success") {
        Global.clearSaveUserInfos();
        this.authenticationService.setIsLoggedIn(false);
        LoginHelper.getInstance().loginChanged(false);
        const url = LoginHelper.getUrlWithoutSessionToken(this.router.url);
        window.open(url, '_self');
      }
      else {
        this.deleteAccountError = this.getString('couldNotDeleteAccount');
      }
    }, err => {
      this.deleteAccountError = this.getString('couldNotDeleteAccount');
    });
  }

  submitItemClicked() {
    this.submitItemUrl = '';
    this.submitItemMessage = '';
    this.submitItemSuccess = false;
    this.submitItemLoading = false;
    this.submitItemLink = '';
    this.submitItemModal.open();
    this.closeDropdown(this.moreDDContent);
  }

  submitItem() {
    if (!this.submitItemUrl || this.submitItemUrl.trim() === '') {
      return;
    }
    this.submitItemLoading = true;
    this.submitItemMessage = '';

    var url = Config.serverUrl + 'SubmitItem.php?itemUrl=' + encodeURIComponent(this.submitItemUrl.trim()) + '&country=' + Global.getCountry();
    var sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if (sessionToken) {
      url += '&sessionToken=' + encodeURIComponent(sessionToken);
    }

    this.http.get(url).subscribe(
      function(res: any) {
        this.submitItemLoading = false;
        this.submitItemLink = '';
        var result = res && res.result ? res.result : '';
        if (result === 'added' || result === 'skipped_exists') {
          this.submitItemSuccess = true;
          this.submitItemMessage = result === 'added'
            ? this.getString('submitMissingItemSuccess')
            : this.getString('submitMissingItemExists');
          if (res.item) {
            this.submitItemLink = this.buildItemDetailUrl(res.item);
          }
        } else if (result === 'no_longer_exist') {
          this.submitItemSuccess = false;
          this.submitItemMessage = this.getString('submitMissingItemNoLongerExist');
        } else if (result === 'failed') {
          this.submitItemSuccess = false;
          this.submitItemMessage = this.getString('submitMissingItemFailed');
        } else if (result === 'invalid_id') {
          this.submitItemSuccess = false;
          this.submitItemMessage = this.getString('submitMissingItemError');
        } else {
          this.submitItemSuccess = false;
          this.submitItemMessage = this.getString('submitMissingItemError');
        }
      }.bind(this),
      function(err) {
        this.submitItemLoading = false;
        this.submitItemSuccess = false;
        var errResult = err && err.error && err.error.result ? err.error.result : '';
        if (errResult === 'no_longer_exist') {
          this.submitItemMessage = this.getString('submitMissingItemNoLongerExist');
        } else if (errResult === 'failed') {
          this.submitItemMessage = this.getString('submitMissingItemFailed');
        } else if (errResult === 'invalid_id') {
          this.submitItemMessage = this.getString('submitMissingItemError');
        } else {
          this.submitItemMessage = this.getString('submitMissingItemError');
        }
      }.bind(this)
    );
  }

  buildItemDetailUrl(item: any): string {
    var trackTypeMap = {
      'movie': 'movies',
      'tv-season': 'seasons',
      'song': 'music',
      'album': 'music-albums',
      'book': 'books',
      'app': 'apps'
    };
    var mediaSegment = trackTypeMap[item.trackType] || item.trackType;
    var country = item.country || Global.getCountry();
    return '/' + country + '/itunes/' + mediaSegment + '/' + item.itemID;
  }

  openCookieSettings() {
    this.closeDropdown(this.moreDDContent);
    this.cookieSettingsModal.open();
  }

  applyCookieSettings(value: string) {
    if(value == "essentials") {
      CookiesHelper.decline();
    }
    else {
      CookiesHelper.accept();
    }
    this.cookieSettingsModal.close();
  }

  openBlogInNewTab(): void {
    const url = 'https://www.cheapcharts.com/blog';
    window.open(url, '_blank');
  }

  openFAQInNewTab() {
    let faqUrl = 'https://api.cheapcharts.com/CheapCharts/API/HTML-Pages/FAQ/faq_ios_en.php';
    if (['de', 'at', 'ch'].includes(this.getCountry())) {
      faqUrl = 'https://api.cheapcharts.com/CheapCharts/API/HTML-Pages/FAQ/faq_ios_de.php';
    }
    window.open(faqUrl, '_blank');
  }

}
